export const PLACEHOLDER = "placeholder";

/* Can be made better? Optional param which is the prop name for id (defaults to id). */
/* If do this, can move to object? */

export const isPlaceholder = (s: string) => s === "placeholder";
